export enum Unit {
  MM = 'mm',
  FT = 'ft'
}